// import {Injectable} from '@angular/core';
// import {Response, Headers, URLSearchParams, RequestOptions} from '@angular/http';
// import {HttpAuth} from './http-auth.service';
// import {environment} from '../../environments/environment';
// import {Observable} from 'rxjs';
// import 'rxjs/add/operator/map';
// import { HvRecommended } from '../models/hv-recommended';

// @Injectable()
// export class HvRecommendedService {

//   private jobUrl: string = `${ environment.apiRoot }/job/`;

//   constructor(private http: HttpAuth) { }

//   public getHvRecommendedByJob(jobId: string): Observable<any> {
//     const params: URLSearchParams = new URLSearchParams();

//     params.append('job_id', String(jobId));

//     const options = new RequestOptions({search: params});

//     return this.http.get(this.hvRecommendedUrl, options)
//       .map(this.extractData)
//       .catch(this.handleError);
//   }

// //noinspection JSMethodCanBeStatic
// private extractData(res: Response) {
//   const body = res.json();

//   return body.data || {};
// }

// //noinspection JSMethodCanBeStatic
// private handleError(error: Response | any) {
//   let errMsg: string;

//   if (error instanceof Response) {
//     const body = error.json() || '';
//     const err = body.meta && body.meta.message || JSON.stringify(body);
//     errMsg = `${err}`;
//   } else {
//     errMsg = error.message ? error.message : error.toString();
//   }

//   console.error(errMsg);

//   return Observable.throw(errMsg);
// }

// }
import {Injectable} from '@angular/core';
import {Response, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {JobsOffer} from '../models/jobs-offer';
import { HvRecommended } from '../models/hv-recommended';
import 'rxjs/add/operator/map';
import {JobsOffersApplicant} from '../models/jobs-offers-applicant'
import { Subject } from 'rxjs/Subject';

@Injectable()
export class HvRecommendedService {


  private hvRecommendedUrl: string = `${ environment.apiRoot }/recommended/`;


  constructor(private http: HttpAuth) { }



  
  public getHvRecommendedByJob(jobId: string, page:number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('job_id', String(jobId));
    params.append('page', String(page));

    const options = new RequestOptions({search: params});

    return this.http.get(this.hvRecommendedUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }



  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/hv-recommended.service.ts